export default {
  minDateMessage: 'Merci de vérifier vos dates de situation',
  maxDateMessage: 'Merci de vérifier vos dates de situation',
  invalidDateMessage: 'Merci de vérifier le format de la date',

  minDatedernierBulletinMessage: 'Merci de vérifier votre saisie',
  maxDatedernierBulletinMessage: 'Merci de vérifier votre saisie',
};
